// eslint-disable-next-line import/prefer-default-export
export function filterOptions(
  searchTerm,
  options = []
) {
  const term = searchTerm.toLowerCase();

  return options.filter(
    (option) => option.value?.toLowerCase().includes(term)
      || option.label?.toLowerCase().includes(term)
  );
}
